import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=5280d2fb&scoped=true&"
import script from "./Policy.vue?vue&type=script&lang=ts&"
export * from "./Policy.vue?vue&type=script&lang=ts&"
import style0 from "./Policy.vue?vue&type=style&index=0&id=5280d2fb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280d2fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
